export default __webpack_public_path__ + "static/media/icon-chart.264a3d7f.svg";